import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class SchemaList extends Component {
  render() {
    return (
      <div style={{ padding: 50 }}>
        Schema List | <Link to="/schemas/1">Edit</Link>
      </div>
    );
  }
}

export default connect(
  state => ({}),
  {}
)(SchemaList);
